import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const AddinChatActionsContext = createContext(null);
export function AddinChatActionsProvider({ submitMessage, isExecuting, children }) {
    return (_jsx(AddinChatActionsContext.Provider, { value: { submitMessage, isExecuting }, children: children }));
}
/**
 * Safe-by-default consumer: returns `null` when used outside the provider
 * so a custom markdown component can fall back to a non-interactive render
 * rather than crashing the chat.
 */
export function useAddinChatActions() {
    return useContext(AddinChatActionsContext);
}
